var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 28.4C15.3695 28.4 11.6 24.6305 11.6 20C11.6 15.3695 15.3695 11.6 20 11.6C24.6305 11.6 28.4 15.3695 28.4 20C28.4 24.6305 24.6305 28.4 20 28.4ZM20 9.5C18.6211 9.5 17.2557 9.77159 15.9818 10.2993C14.7079 10.8269 13.5504 11.6004 12.5754 12.5754C10.6062 14.5445 9.5 17.2152 9.5 20C9.5 22.7848 10.6062 25.4555 12.5754 27.4246C13.5504 28.3996 14.7079 29.1731 15.9818 29.7007C17.2557 30.2284 18.6211 30.5 20 30.5C22.7848 30.5 25.4555 29.3938 27.4246 27.4246C29.3938 25.4555 30.5 22.7848 30.5 20C30.5 18.6211 30.2284 17.2557 29.7007 15.9818C29.1731 14.7079 28.3996 13.5504 27.4246 12.5754C26.4496 11.6004 25.2921 10.8269 24.0182 10.2993C22.7443 9.77159 21.3789 9.5 20 9.5ZM21.05 14.75H18.95V18.95H14.75V21.05H18.95V25.25H21.05V21.05H25.25V18.95H21.05V14.75Z",
    fill: "#1F1F1F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.4b5efc05641307b8143149b5c6d7a873.svg";
export { ForwardRef as ReactComponent };